export default "__VITE_ASSET__7c475c5a__"